import { render } from "./FlexSelector.vue?vue&type=template&id=6078a7c7&scoped=true"
import script from "./FlexSelector.vue?vue&type=script&lang=ts"
export * from "./FlexSelector.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6078a7c7"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QInput,QBtn});
